import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Utilities
import fetcher from "utilities/Fetcher";

const _url:string = '/player/quizEvent';

export const getQuizEvents = createAsyncThunk(
  `${Reducers.QuizEvents}/Get quiz events`,
  async (quizId:string, { rejectWithValue }) => {
    const response:Response = await fetcher(`${_url}?quizId=${quizId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);
